module.exports = __webpack_public_path__ + "img/workplan-laptop.jpg?fc38800e1ae25aa38a2c269893bd64e9";